module.exports = __webpack_public_path__ + "assets/img/Slice 164(3).84bbe9b5.png";